<template>
  <div class="container mb-5 d-flex justify-content-center align-items-center min-vh-100">
    <div
      class="register-card bg-white border-primary animate__animated animate__fadeInDown border p-4 rounded-4 shadow"
      style="max-width: 450px; width: 100%;"
    >
      <h3 class="text-center text-primary fw-bold mb-4">
        <i class="fas fa-user-plus me-2"></i> Înregistrare Client
      </h3>
      <form @submit.prevent="submit">
        <div class="mb-3">
          <label class="form-label fw-semibold">
            <i class="fas fa-user me-1 text-muted"></i> Nume complet
          </label>
          <input v-model="form.full_name" class="form-control form-control-lg" placeholder="ex: Popescu Andrei" required />
        </div>
        <div class="mb-3">
          <label class="form-label fw-semibold">
            <i class="fas fa-envelope me-1 text-muted"></i> Email
          </label>
          <input v-model="form.email" type="email" class="form-control form-control-lg" placeholder="ex: andrei@email.ro" required />
        </div>
        <div class="mb-3">
          <label class="form-label fw-semibold">
            <i class="fas fa-phone me-1 text-muted"></i> Telefon
          </label>
          <input v-model="form.phone" class="form-control form-control-lg" placeholder="07xx xxx xxx" required />
        </div>
        <div class="mb-3">
          <label class="form-label fw-semibold">
            <i class="fas fa-lock me-1 text-muted"></i> Parolă
          </label>
          <input v-model="form.password" type="password" class="form-control form-control-lg" placeholder="••••••••" required />
        </div>
        <div class="mb-4">
          <label class="form-label fw-semibold">
            <i class="fas fa-robot me-1 text-muted"></i> Cât fac {{ captchaQ }}?
          </label>
          <input v-model="captchaInput" type="text" class="form-control form-control-lg" required />
        </div>
        <div class="mb-3 form-check">
          <input v-model="agreedToTerms" type="checkbox" class="form-check-input" id="termsCheck" required />
          <label class="form-check-label small" for="termsCheck">
            Am citit și sunt de acord cu
            <router-link to="/termeni" target="_blank" class="text-primary text-decoration-underline">Termenii și condițiile</router-link>
            și
            <router-link to="/confidentialitate" target="_blank" class="text-primary text-decoration-underline">Politica de confidențialitate</router-link>.
          </label>
        </div>

        <button type="submit" class="btn btn-primary w-100 btn-lg shadow-sm hover-scale">
          <i class="fas fa-user-check me-2"></i> Înregistrează-te
        </button>
      </form>
      <div class="text-center mt-3">
        <router-link to="/client/login" class="text-decoration-none small text-muted">
          <i class="fas fa-sign-in-alt me-1"></i> Ai deja cont? Autentifică-te
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import api from '@/api/axios'
import Swal from 'sweetalert2'
import { useRouter } from 'vue-router'

const router = useRouter()

const form = ref({
  full_name: '',
  email: '',
  phone: '',
  password: '',
})
const captchaInput = ref('')

// ✅ Captcha dinamic
const captchaA      = Math.floor(Math.random() * 9) + 1
const captchaB      = Math.floor(Math.random() * 9) + 1
const captchaQ      = `${captchaA} + ${captchaB}`
const captchaAnswer = String(captchaA + captchaB)

const agreedToTerms = ref(false)

const submit = async () => {
  if (!agreedToTerms.value) {
    Swal.fire('Atenție', 'Trebuie să accepți termenii și condițiile pentru a continua.', 'warning')
    return
  }
  if (captchaInput.value.trim() !== captchaAnswer) {
    Swal.fire('Eroare captcha', 'Răspuns greșit la întrebare.', 'error')
    return
  }

  try {
    await api.post('/client/register/', form.value)
    await Swal.fire('Succes!', 'Cont creat cu succes! Te redirecționăm la login.', 'success')
    // ✅ Redirect după înregistrare
    router.push('/client/login')
  } catch (err) {
    Swal.fire('Eroare!', err.response?.data?.error || 'Ceva n-a mers.', 'error')
  }
}
</script>

<style scoped>
.hover-scale {
  transition: transform 0.2s ease-in-out;
}
.hover-scale:hover {
  transform: scale(1.03);
}
</style>